module.exports = __webpack_public_path__ + "static/media/navbar-ico-3-active.698809fb.svg";